export enum UnitOfMeasurement {
    Imperial = "Imperial",
    Metric = "Metric"
}